import { useTranslation } from 'react-i18next';
import { createColumnHelper } from '@tanstack/react-table';
import useTable from 'components/table/hooks/useTable';
import { ICal } from 'models/ICal';
import { CalendarImportTableStyled } from '../CalendarImportSection.styles';
import ActionsCell from './cells/ActionsCell';
import ProviderCell from './cells/ProviderCell';

const CalendarImportTable = ({
  icals,
  isLoading,
}: {
  icals: ICal[];
  isLoading: boolean;
}) => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<ICal>();

  const columns = [
    columnHelper.accessor('type', {
      header: t('pageAutomations.calendarTools.calendarImportSection.provider'),
      cell: ProviderCell,
    }),
    columnHelper.accessor('url', {
      header: t('pageAutomations.calendarTools.calendarImportSection.icalLink'),
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const tableInstance = useTable({
    data: icals,
    columns,
    manualPagination: true,
    pageCount: 1,
  });

  return (
    <CalendarImportTableStyled
      data-testid="ical-links-table"
      tableInstance={tableInstance}
      isLoading={isLoading}
    />
  );
};

export default CalendarImportTable;
